<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <!-- Sidebar Content -->
      <div class="sidebar-content" :class="{ show: mqShallShowLeftSidebar }">
        <!-- Sidebar close icon -->
        <span class="sidebar-close-icon">
          <feather-icon
            icon="XIcon"
            size="16"
            @click="$emit('update:mq-shall-show-left-sidebar', false)"
          />
        </span>

        <!-- Header -->
        <div class="chat-fixed-search">
          <div class="d-flex align-items-center w-100">
            <!-- Search -->
            <b-input-group
              class="input-group-merge ml-0 w-100 round"
              v-show="isShowSearch"
            >
              <b-input-group-prepend is-text class="">
                <b-form-select
                  v-model="query.searchType"
                  :options="searchTypeOptions"
                  size="sm"
                  class="border-0 ml-1"
                  @input="onChangeSearchType"
                />
              </b-input-group-prepend>
              <b-form-input
                v-model="query.search"
                v-debounce:500ms="search"
                :placeholder="$t('general.search')"
              />
            </b-input-group>
            <div class="chat-filter" v-show="!isShowSearch">
              <div class="filter">
                <h6
                  class="cursor-pointer"
                  :class="{
                    active: option.value == query.filter,
                  }"
                  v-for="option in filterOptions"
                  :key="option.value"
                  @click="changeFilter(option.value)"
                >
                  {{ $t(option.text) }}
                </h6>
              </div>
            </div>

            <feather-icon
              icon="SearchIcon"
              size="22"
              class="ml-1 cursor-pointer"
              :class="{
                'text-primary': isShowSearch,
              }"
              @click="searching"
            />
          </div>
        </div>
        <div class="position-relative chat-chanel-wrapper">
          <div class="chat-user-list-wrapper list-group scroll-area overflow-y" ref="container">
            <ul class="chat-users-list chat-list media-list">
              <queue-alert></queue-alert>
              <chat-contact
                v-for="channel in channels"
                :ref="channel.id === activeChannel.id ? 'activeChannel' : null"
                :key="channel.latestMessage.createdAt"
                :channel="channel"
                :is-active="
                  activeChannel.latestMessage &&
                  activeChannel.latestMessage.createdAt ===
                    channel.latestMessage.createdAt
                "
                tag="li"
                :class="{
                  active:
                    activeChannel.latestMessage &&
                    activeChannel.latestMessage.createdAt ===
                      channel.latestMessage.createdAt,
                }"
                @click="onChannelChange(channel)"
              />
            </ul>
            <div class="infinite-wrapper">
              <infinite-loading
                ref="infiniteLoading"
                @infinite="listChannel"
                :identifier="identifier"
              >
                <div slot="spinner" class="mt-2">
                  <b-spinner label="Spinning"></b-spinner>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading>
            </div>
          </div>
        </div>
        <div class="chat-fixed-bottom border">
          <div class="d-flex align-items-center w-100 justify-content-between">
            <div>
              <b-button
                @click="openShortcut()"
                variant="link"
                no-caret
                toggle-class="p-0"
                right
              >
                <feather-icon
                  icon="CornerDownRightIcon"
                  size="17"
                  class="align-middle text-body text-primary"
                />
              </b-button>
              <b-button
                @click="openSettings()"
                style="padding: 0 !important"
                variant="link"
                no-caret
                toggle-class="p-0"
                right
              >
                <feather-icon
                  icon="SettingsIcon"
                  size="17"
                  class="align-middle text-body text-primary"
                />
              </b-button>
            </div>

            <div style="display: flex; align-items: center; position: relative">
              <!-- date filter -->
              <feather-icon
                @click="toggleDialog"
                icon="CalendarIcon"
                size="17"
                class="align-middle text-body"
                :class="{ 'text-primary': query.startDate || query.endDate }"
                style="cursor: pointer"
              />

              <!-- Fixed dialog -->
              <div
                v-if="dialogVisible"
                class="fixed-dialog"
                style="position: absolute; top: -285px; left: 0px"
              >
                <div>
                  <n-search-container
                    @search="search()"
                    @reset="resetDate"
                    :show-header="false"
                    :fields="dateInputs"
                    :default-visible="true"
                  >
                    <n-search-input :fields="dateInputs" v-model="query">
                    </n-search-input>
                  </n-search-container>
                </div>
              </div>
              <div style="margin-right: 1.2rem" class="d-flex flex-row"></div>

              <div
                v-if="query.searchType != 'm' || !query.search.trim()"
                class="d-flex flex-row"
              >
                <div class="dropdown chat-filter-dropdown my-1">
                  <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                    <template #button-content>
                      <feather-icon
                        icon="UserIcon"
                        size="17"
                        class="align-middle text-body text-primary"
                        v-if="
                          query.type == 'assignToMe' ||
                          (query.type == 'allConversation' &&
                            query.operator == userData.id)
                        "
                        @click="dialogVisible = false"
                      />
                      <feather-icon
                        icon="UserIcon"
                        size="17"
                        class="align-middle text-body"
                        v-else-if="
                          query.type == 'allConversation' && query.operator
                        "
                        @click="dialogVisible = false"
                      />
                      <feather-icon
                        icon="UsersIcon"
                        size="17"
                        class="align-middle text-body"
                        v-else-if="query.type == 'allConversation'"
                        @click="dialogVisible = false"
                      />
                      <feather-icon
                        icon="UserXIcon"
                        size="17"
                        class="align-middle text-body"
                        v-else
                        @click="dialogVisible = false"
                      />
                    </template>
                    <b-dropdown-item @click="changeOperator('assignToMe')">
                      {{ $t("chat.assignToMe") }}
                      <feather-icon
                        class="float-right"
                        icon="CheckIcon"
                        size="22"
                        v-if="query.type == 'assignToMe'"
                      />
                    </b-dropdown-item>
                    <b-dropdown-item @click="changeOperator('unassign')">
                      {{ $t("chat.unassign") }}
                      <feather-icon
                        class="float-right"
                        icon="CheckIcon"
                        size="22"
                        v-if="query.type == 'unassign'"
                      />
                    </b-dropdown-item>
                    <b-dropdown-item @click="changeOperator('allConversation')">
                      {{ $t("chat.allConversation") }}
                      <feather-icon
                        class="float-right"
                        icon="CheckIcon"
                        size="22"
                        v-if="query.type == 'allConversation'"
                      />
                    </b-dropdown-item>

                    <b-dropdown-divider
                      v-show="query.type == 'allConversation'"
                    ></b-dropdown-divider>

                    <b-dropdown-form v-show="query.type == 'allConversation'">
                      <b-form-group>
                        <label class="d-block">
                          {{ $t("field.operator") }}
                        </label>
                        <n-async-single-select
                          v-model="query.operator"
                          :init-options="query.operator"
                          repository="chatOperator"
                          selection-key="id"
                          selection-label="name"
                          :clearable="true"
                          @input="onChangeOperator"
                        ></n-async-single-select>
                      </b-form-group>
                    </b-dropdown-form>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <chat-settings-model ref="openSettingsModal" @reloadChannel="reloadData" />
    <chat-shortcut-model ref="openShortcutModal" />
  </div>
</template>

<script>
import {
  BModal,
  BAvatar,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BButton,
  BSpinner,
  BDropdown,
  BDropdownDivider,
  BDropdownItem,
  BDropdownForm,
  BFormGroup,
  BFormRadioGroup,
  BFormRadio,
  BFormSelect,
} from "bootstrap-vue";
import ChatContact from "./ChatContact.vue";
import InfiniteLoading from "vue-infinite-loading";
import NAsyncSingleSelect from "@/components/NAsyncSingleSelect";
import ChatSettingsModel from "./ChatSettingsModel.vue";
import ChatShortcutModel from "./ChatShortcutModel.vue";
import { bus } from "@/libs/bus";
import useJwt from "@/auth/jwt/useJwt";
import QueueAlert from "@/components/QueueAlert.vue";
import NSearchContainer from "@/components/NSearchContainer";
import NSearchInput from "@/components/NSearchInput";
import DateInputs from "./searchDate.js";

import store from "@/store";
import ComingConversationLineChart from "../conversationOverview/ComingConversationLineChart.vue";

export default {
  components: {
    NSearchContainer,
    NSearchInput,
    // BSV
    BModal,
    BAvatar,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BButton,
    BSpinner,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    BDropdownForm,
    BFormGroup,
    BFormRadioGroup,
    BFormRadio,
    BFormSelect,
    QueueAlert,

    // 3rd party
    InfiniteLoading,

    // SFC
    ChatContact,
    NAsyncSingleSelect,

    // Component
    ChatSettingsModel,
    ChatShortcutModel,
  },
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
    activeChannel: {
      type: Object,
      default: () => {},
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    connectionStatus: {
      type: Boolean,
      default: true,
    },
    identifier: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    userData: function () {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  data() {
    return {
      isShowSearch: this.$route.query.search ? true : false,
      assignIcon: "UserIcon",
      filterOptions: [],
      query: {
        operator: this.$route.query.operator || null,
        type:
          this.$route.query.type ||
          store.state.app.chatQuery.type ||
          "allConversation",
        filter: this.$route.query.filter || "",
        search: this.$route.query.search || "",
        searchType: this.$route.query.searchType || "m",
        startDate: this.$route.query.startDate || null,
        endDate: this.$route.query.endDate || null,
        cache: this.$route.query.cache,
        channel: this.$route.query.channel || null,
        channelId: this.$route.query.channelId || null,
        from: this.$route.query.from || null,
        msgStartDate: this.$route.query.msgStartDate || null,
      },
      searchTypeOptions: [
        { value: "m", text: this.$t("general.message") },
        { value: "c", text: this.$t("general.channel") },
      ],
      dialogVisible: false,
      isModifierPressed: false,
      debouncedNavigate: null
    };
  },
  created() {
    const chatQuery = {};
    if (this.query.cache != "no") {
      Object.keys(store.state.app.chatQuery).forEach((key) => {
        if (!this.query[key]?.trim()) {
          chatQuery[key] = store.state.app.chatQuery[key];
        } else if (this.query[key] == "noCache") {
          chatQuery[key] = "";
        }
      });
    }
    this.query = { ...this.query, ...chatQuery };
    this.$nextTick(() => {
      this.mapFilterOption(this.query.type);
      this.changeFilter(this.query.filter);

      bus.$on("notificationClick", (type) => {
        if (type == "chat") {
          this.mapFilterOption(this.query.type);
          this.changeFilter(this.query.filter);
        }
      });
    });
    this.debouncedNavigate = _.debounce((direction) => {
      const channel = this.findChannelAdjacent(direction);
      if (channel) {
        // Visual update only
        this.scrollToActive();
        this.$nextTick(() => {
          // Actual channel change
          this.onChannelChange(channel);
        });
      }
    }, 100, {
      leading: true,
      trailing: false,
      maxWait: 300
    });
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);
  },
  beforeDestroy() {
    bus.$off("notificationClick");
    if (this.debouncedNavigate) {
      this.debouncedNavigate.cancel();
    }
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
  },
  methods: {
    reset() {
      this.$refs.search.reset();
      this.updateQuerySting();
    },
    resetDate() {
      this.query.startDate = "";
      this.query.endDate = "";
      this.updateQuerySting();
      this.toggleDialog();
      this.$emit("filter", this.query);
    },
    toggleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    reloadData() {
      console.log("this.chatleft");
      this.$emit("closeChannel", {});
      this.search();
    },
    openSettings() {
      this.$refs.openSettingsModal.show();
    },
    openShortcut() {
      console.log(this.$refs);
      this.$refs.openShortcutModal.show();
    },
    listChannel($state = null) {
      this.$emit("load-channel", $state);
    },
    onChangeOperator() {
      this.query.search = "";
      this.query.filter = "";
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    onChangeSearchType() {
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    onChannelChange(channel) {
      this.$emit("open-chat", channel);
    },
    changeFilter(filter) {
      let channel = null;
      if (this.$route.query.channel) {
        channel = this.$route.query.channel;
      }
      this.query.filter = filter;
      this.updateQuerySting();
      if (channel) {
        this.query.channel = channel;
      }
      this.$emit("filter", this.query);
    },
    changeOperator(type) {
      this.query.search = "";
      this.query.filter = "";
      this.query.operator = "";
      this.mapFilterOption(type);
      this.query.type = type;
      this.updateQuerySting();
      this.$emit("filter", this.query);
    },
    mapFilterOption(type) {
      if (type == "unassign") {
        this.filterOptions = [];
      } else {
        this.filterOptions = [
          {
            value: "",
            text: "chat.all",
          },
          {
            value: "unread",
            text: "chat.unread",
          },
          {
            value: "unresolved",
            text: "chat.unresolved",
          },
          {
            value: "resolved",
            text: "chat.resolved",
          },
          {
            value: "banned",
            text: "chat.banned",
          },
        ];
      }
    },
    searching() {
      this.isShowSearch = !this.isShowSearch;
      if (!this.isShowSearch && this.query.search) {
        this.query.search = "";
        this.search();
      }
    },
    search() {
      if (this.query.endDate) {
        let endDate = new Date(this.query.endDate)
        endDate.setSeconds(59)
        this.query.endDate = endDate.toISOString()
      }
      this.updateQuerySting();
      this.$emit("filter", this.query);
      this.dialogVisible = false;
    },
    updateQuerySting() {
      this.$router.replace({ query: this.query });
      this.$nextTick(() => {
        if (this.query.cache != "no") {
          store.commit("app/UPDATE_CHAT_QUERY", {
            ...this.query,
            channel: undefined,
            channelId: undefined,
            from: undefined,
            msgStartDate: undefined,
          });
        }
      });
    },
    findChannelAdjacent(direction) {
      if(!this.activeChannel?.id) {
        return this.channels[0] ? this.channels[0] : null
      }
      const currentIndex = this.channels.findIndex(item => item.id === this.activeChannel?.id)

      if (currentIndex === -1) return this.channels[0] ? this.channels[0] : null;

      let newIndex
      if (direction === 'next') {
        newIndex = currentIndex + 1 >= this.channels.length ? 0 : currentIndex + 1;
      } else {
        newIndex = currentIndex - 1 < 0 ? this.channels.length - 1 : currentIndex - 1;
      }

      return this.channels[newIndex];
    },
    handleKeyDown(event) {
      if (event.metaKey || event.ctrlKey) {
        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();
            this.debouncedNavigate('previous');
            break;

          case 'ArrowDown':
            event.preventDefault();
            this.debouncedNavigate('next');
            break;
        }
      }
    },

    handleKeyUp(event) {
      if (event.key === 'Control' || event.key === 'Meta') {
        this.isModifierPressed = false;
      }
    },

    scrollToActive() {
      this.$nextTick(() => {
        const activeElement = this.$refs.activeChannel?.[0]?.$el;
        const container = this.$refs.container;

        if (activeElement && container) {
          const containerRect = container.getBoundingClientRect();
          const elementRect = activeElement.getBoundingClientRect();

          // Calculate scroll position to center the element
          const scrollTop = (
            activeElement.offsetTop -
            (container.clientHeight / 2) +
            (elementRect.height / 2)
          );

          // Smooth scroll to position
          container.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      });
    }
  },
  setup() {
    return {
      dateInputs: DateInputs,
    };
  },
};
</script>

<style scoped>
.input-group-text {
  padding: 0 !important;
}

.custom-select:focus {
  box-shadow: none !important;
}

.fixed-dialog {
  position: fixed;
  height: 274px;
  top: 100px;
  left: 400px;
  width: 300px;
  z-index: 1000;
  background-color: #fff;
  border: 0px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
